import React from 'react'
import { StyledPlayOverlay } from 'component-library/content/Video/components/PlayOverlay/PlayOverlay.styled'
import { PlayButton, PlayButtonProps } from 'component-library/buttons/PlayButton/PlayButton'

export interface Props extends PlayButtonProps {
    play: () => void
}

export const playOverlayClassName = 'Play-Overlay'

export const PlayOverlay: React.FC<Props> = props => (
    <StyledPlayOverlay className={playOverlayClassName} onClick={props.play}>
        <PlayButton
            onClick={props.play}
            isCentered={props.isCentered}
            isInversed={props.isInversed}
        />
    </StyledPlayOverlay>
)
PlayOverlay.displayName = 'PlayOverlay'
